export default "__VITE_ASSET__XM2$F0_f__"